import { motion } from 'framer-motion';
import AboutUsCard from './AboutUsCard';
import RevealText from './RevealText';
import SectionDivider from './SectionDivider';

// Orchestrates the two paragraphs — fires once in view, then staggers children.
// staggerChildren: 0.15 means paragraph 2 starts 0.15s after paragraph 1.
const textContainerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.15 } },
};

// Each paragraph fades up by 24px.
// No blur here — blurring long readable body text during transition looks messy.
// No horizontal slide — body copy should feel grounded, not flying in from somewhere.
const paraVariants = {
  hidden: { opacity: 0, y: 32 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: [0.16, 1, 0.3, 1] },
  },
};

const AboutUsSection = () => {
  return (
    <>
      <SectionDivider className='px-4' label="Novinarstvo i mediji" />
      <section className='flex flex-col py-12 lg:py-20 overflow-hidden min-h-svh justify-center'>
        <div className='max-w-6xl mx-auto w-full px-4'>
          <header className='pt-4 pb-2 text-center'>
            <h1 className='text-5xl font-extrabold text-white md:text-6xl lg:text-8xl'>
              <RevealText>O nama</RevealText>
            </h1>
          </header>

          <div className='flex flex-col lg:flex-row mt-8 lg:mt-4 lg:items-stretch'>
            <div className='mx-auto sm:pt-10 lg:w-[40%] lg:-mt-10'>
              <AboutUsCard />
            </div>

            {/* Text container — whileInView fires when this block enters the viewport,
                then staggerChildren cascades the two paragraphs with a 0.15s gap.
                amount: 0.2 — fires when 20% of the text block is visible. */}
            <motion.div
              className='mx-auto lg:w-[60%] lg:flex lg:flex-col lg:justify-between'
              variants={textContainerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
            >
              <motion.p
                className='px-8 pt-10 text-lg text-white lg:text-2xl text-justify font-main'
                variants={paraVariants}
              >
                Početkom 2022. ekipa studenata Fakulteta za medije i odnose s javnošću Sveučilišta u Dubrovniku, odlučila je zagrebati ispod površine PR-a.
                Odlučili su otići do Zagreba s projektom "Posjet u PR agencije - PR iz prve ruke".
                <br /> Ali, to nije bilo dovoljno. Iskustvo je bilo PRedobro da bi ostalo samo uspomena.
                I naravno, na jednoj kavi pala je ideja: "Zašto ne dovesti to <u>iskustvo</u> u Dubrovnik?"
              </motion.p>

              <motion.p
                className='px-8 pt-8 text-lg text-white lg:text-2xl text-justify font-main'
                variants={paraVariants}
              >
                I eto ih danas, s <span className='span'>PEP Konferencijom</span>, gdje ludilo i hrabrost rastu iz godine u godinu. Ideja koja je prerasla iz šalice kave sada osvaja Dubrovnik!
              </motion.p>
            </motion.div>
          </div>
        </div>
      </section>
    <SectionDivider className='pt-8' label="Karijerni put" labelPosition='right'/>
    </>
  );
};

export default AboutUsSection;
